import { DESKTOP_PATH } from './filesystem';

/** The first-visit tray balloon — XP's "Take a tour of Windows XP" moment. */
export const balloon = {
  title: 'Welcome to teon.io',
  body: 'Click to learn more about me.',
  /** What clicking the balloon does. */
  action: {
    appId: 'notepad',
    args: { file: `${DESKTOP_PATH}\\About me.txt` },
  },
  /** How long before it dismisses itself. */
  timeoutMs: 12_000,
  /** Delay after the desktop appears before it pops up. */
  delayMs: 1200,
} as const;
